import { L } from '@lang';
import { Trans } from 'react-i18next';
import { Icon24HandPointUpOutline } from '@vkontakte/icons';
import { IconAddSquare24, IconShareExternal24 } from '../../../../shared/icons';
import { AppInfo } from '../../../../widgets/AppInfo';
import { InstallStep, installStepBoldClassName } from '../../../../widgets/InstallStep';
import { NativeGlassCard } from '../../../../widgets/NativeGlassCard';
import { NativeSeparator } from '../../../../widgets/NativeSeparator';
import styles from './InstallCard.module.css';

export function InstallCard() {
  return (
    <NativeGlassCard>
      <AppInfo title={L.t('pwa_install_safari_old_app_title')} subtitle={L.t('pwa_install_safari_old_app_subtitle')} />
      <NativeSeparator />
      <p className={styles.description}>{L.t('pwa_install_safari_old_description')}</p>
      <NativeSeparator />
      <div className={styles.steps}>
        <InstallStep icon={<IconShareExternal24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_safari_old_share_button_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
        <InstallStep icon={<IconAddSquare24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_safari_old_add_to_home_screen_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
        <InstallStep icon={<Icon24HandPointUpOutline />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_safari_old_launch_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
      </div>
    </NativeGlassCard>
  );
}
